import { AuditFormController } from './pages/audit-form/audit-form.controller'
import { AuditModelsController } from './pages/audit-models/audit-models.controller'
import { AuditSocialMediaController } from './pages/audit-social-media/audit-social-media.controller'
import { AuditListController } from './pages/audit-list/audit-list.controller'
import { AuditController } from './audit.controller'

const auditListRoute = '/audits/list?audit'

const checkSysAdminAdminAccess = [
  '$rootScope',
  '$q',
  '$state',
  ($rootScope, $q, $state) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons()
      .then(() => {
        if ($rootScope.isUserSysAdminAdmin()) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

const checkSysAdminAdminDesignerAccess = [
  '$rootScope',
  '$q',
  '$state',
  ($rootScope, $q, $state) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons()
      .then(() => {
        if ($rootScope.isUserSysAdminAdminDesigner()) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })
      .catch(() => {
        deferred.reject()
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('audit', {
      url: '/audits',
      abstract: true,
      views: {
        '': {
          templateUrl: '/audit/audit.html?$$REVISION$$',
          controller: AuditController
        },
        'secondLevelMenu@audit': {
          templateUrl: '/audit/audit-sidebar-menu.html?$$REVISION$$'
        }
      }
    })
    .state('audit.list', {
      parent: 'audit',
      url: '/list?audit',
      reloadOnSearch: false,
      views: {
        'list@audit': {
          templateUrl: '/audit/pages/audit-list/audit-list.html?$$REVISION$$',
          controller: AuditListController
        }
      }
    })
    .state('auditForm', {
      url: '/audits/:id/form',
      views: {
        '': {
          templateUrl: '/audit/pages/audit-form/audit-form.html?$$REVISION$$',
          controller: AuditFormController
        }
      },
      params: {
        redirect: null
      }
    })
    .state('audit.models', {
      parent: 'audit',
      url: '/models',
      resolve: {
        checkSysAdminAdminAccess
      },
      views: {
        'models@audit': {
          templateUrl: '/audit/pages/audit-models/audit-models.html?$$REVISION$$',
          controller: AuditModelsController
        }
      }
    })
    .state('audit.socialMedia', {
      parent: 'audit',
      url: '/social-media?selectedTab',
      reloadOnSearch: false,
      resolve: {
        checkSysAdminAdminDesignerAccess
      },
      params: {
        selectedTab: null,
        accountId: null
      },
      views: {
        'socialMedia@audit': {
          templateUrl: '/audit/pages/audit-social-media/audit-social-media.html?$$REVISION$$',
          controller: AuditSocialMediaController
        }
      }
    })

  $urlRouterProvider.when('/audits/list/?audit', auditListRoute)
  $urlRouterProvider.when('/audits/?audit', auditListRoute)
  $urlRouterProvider.when('/audits?audit', auditListRoute)
}

export const auditRoutes = routes
